module.exports = __webpack_public_path__ + "img/tooth14.7131cff4.png";